// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__dRrgQ","row":"styles_row__p-05B","section":"styles_section__1QwBQ","actionBtn":"styles_actionBtn__1PFyo","newButton":"styles_newButton__Ijn2Z"};